<!--
功能: 课件预览的章节组件

属性:
属性:
chapter     : 章节对象
indent      : 缩进数量

事件:
on-video: 点击资源为视频的章节触发，参数为视频的 ID 和 继续播放时间点

Slot: 无

案例:
<CoursewarePlayVideoChapter :chapter="chapter" @on-video="play"/>
-->
<template>
    <div class="courseware-play-video-chapter">
        <div class="indents">
            <span v-for="i in indent" :key="i" class="indent"></span>
        </div>

        <div v-if="chapter.isMedia === 1" class="content playing elide">
            <Icon v-if="playing" type="ios-podium" size="16" class="icon-playing"/>
            <Icon v-else type="ios-play" :style="iconPlaying" size="12" class="icon-video"/>
            <span v-if="isFree(chapter.id)" style="color:red">试听</span>
            <div class="name elide" :style="playing" :title="chapter.title" @click="playVideo">{{ chapter.title }}</div>

            <!-- 正播放的视频为当前章节的视频，显示播放状态的图标 -->
            <div class="duration">
                {{ chapter.mediaDuration | formatTime }}  {{ chapter.mediaDuration | learnScale(chapter.sumTime) }}
            </div>
        </div>
        <div v-else class="content elide" @click="childrenShow = !childrenShow">
           <Icon v-if="childrenShow" type="ios-arrow-down" size="16" class="icon-playing"/>
           <Icon v-else type="ios-arrow-forward" size="16" class="icon-playing"/>
            <div class="name elide" :title="chapter.title">{{ chapter.title }}</div>
        </div>

        <!-- 子章节 -->
        <template v-if="chapter.children && chapter.children.length">
            <div v-show="childrenShow" class="children">
                <CoursewarePlayVideoChapter v-for="child in chapter.children"
                        :chapter="child"
                        :indent="indent+1"
                        :key="child.id"
                        @on-chapter="$emit('on-chapter', $event)"/>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'CoursewarePlayVideoChapter',
    props: {
        chapter: { type: Object, required: true }, // 章节
        indent : { type: Number, default: 0 },     // 缩进数量
    },
    data() {
        return {
            childrenShow: true,
            chapterIds: this.$store.state.chapterIds, // 试听章节
        };
    },
    methods: {
        playVideo() {
            // 是否试听
            if (this.chapterIds !='') {
                if (this.isFree(this.chapter.id)) {
                    const chapterMaps = this.$store.state.mapChapters;
                    // console.log('chapterMaps==', chapterMaps);
                    this.chapter = chapterMaps.get(this.chapter.id);
                    // 传递父组件参数
                    this.$emit('on-chapter', { chapterId:this.chapter.id, lastTime:this.chapter.lastTime, changeChatper: true });
                    this.$store.commit('setPlayVideoChapterId', this.chapter.id);
                    this.$store.commit('setPlayVideoChapter', this.chapter);
                }
            } else {
                const chapterMaps = this.$store.state.mapChapters;
                // console.log('chapterMaps==', chapterMaps);
                this.chapter = chapterMaps.get(this.chapter.id);
                // 传递父组件参数
                this.$emit('on-chapter', { chapterId:this.chapter.id, lastTime:this.chapter.lastTime, changeChatper: true });
                this.$store.commit('setPlayVideoChapterId', this.chapter.id);
                this.$store.commit('setPlayVideoChapter', this.chapter);
            }
        },
        isFree(id) {
            return (this.chapterIds.indexOf(id)>-1);
        },
    },
    filters: {
        // 已学比例
        learnScale(mediaDuration, sumTime) {
            if (!sumTime || !mediaDuration || mediaDuration === 0) return '';
            // 计算已学比例
            const scale = (sumTime/mediaDuration) * 100;

            // 已学比例超过 100% 那么展示 100%, 否则展示实际比例保留一位有效数字
            if (scale >= 100) { return '/ 已学 100%'; }
            return '/ 已学 '+ Math.round(scale) +' %';
        }
    },
    computed: {
        // 正在播放的视频为当前章节的视频返回 true，否则返回 false
        playing() {
            if (this.chapter.id === this.$store.state.playVideoChapterId) {
                return 'color: #2d8cf0; font-size: initial;';
            }
            return '';
        },
        iconPlaying() {
            if (this.chapter.id === this.$store.state.playVideoChapterId) {
                return 'background: #2d8cf0';
            }
            return '';
        },
        triggerView() {
            return this.childrenShow;
        },
    }
};
</script>

<style lang="scss">
.courseware-play-video-chapter {

    display: grid;
    grid-template-columns: max-content 1fr;
    align-items: center;

    .indents {
        height: 30px;

        .indent {
            display: inline-block;
            width : 25px;
            height: 25px;
        }
    }

    .content {
        display: grid;
        grid-template-columns: max-content max-content 1fr;
        align-items: center;
        .name {
            flex: 1;
            cursor: pointer;
            // color: rgba(255, 255, 255, 0.6);
            color: #dcdee2;
        }
    }

    .content.playing {
        .name {
            color: #dcdee2;
            cursor: pointer;
        }

        .icon-video {
            border-radius: 100%;
            margin-right: 6px;
            padding: 1px 0 1px 2px;
            background: #dcdee2;;
        }
        .icon-playing {
            transition: all .6s;
        }

        &:hover {
            .name {
                color: rgb(45, 140, 240);
                transition: all .6s;
            }

            .icon-video {
                background: rgb(45, 140, 240);
                transition: all .6s;
            }
        }

        .duration {
            grid-column: 2 / span 2;
            font-size: 12px;
            color: #808695;
        }

    }
    .children {
        grid-column: span 2;
    }
}
</style>
